const PbxxRecord = require('../pbxx_record')

module.exports = class Campaign extends PbxxRecord {
  static get class_name() {
    return 'Campaign'
  }

  get can_add_funds() {
  	return this.retailer_match_funding_enabled && (this.end_date === null || moment().isBefore(this.end_date))
  }

  get is_advanced() {
    return this.campaign_type === 'template'
  }

  get is_quick_share() {
    return this.campaign_type === 'simple'
  }

  get is_standard() {
    return this.campaign_type === 'frame'
  }

  get landing_page_preview_url() {
    // TODO will need to check for this.landing_page and support legacy LPs
    // TODO the landing_page itself should be able to tell us this
    let url = ''

    if (this.is_standard || this.is_advanced) {
      url = `http://client.promoboxx.com/client/${ this.brand && this.brand.abbr ? this.brand.abbr : '***missing***' }/${ this.creative_path ? this.creative_path : '***missing***' }/index.php`
    }

    return url
  }

  reset() {
    return this._mapper().reset(this.id).then((response) => {
      return this
    }, (error) => {
      throw(error)
    })
  }

  bulk_update_share_settings(opts) {
    return this._mapper().bulk_update_share_settings(this.id, opts).then((response) => {
      return this
    }, (error) => {
      throw(error)
    })
  }
}
